import { SectionHeading } from './common';

const pillars = [
  {
    icon: 'ri-compass-3-line',
    t: '我们的定位',
    d: '校园反转社是一群爱追热点、更爱较真的内容爱好者共同维护的吃瓜求证站，专注把校园热议事件讲完整、讲客观。',
  },
  {
    icon: 'ri-rocket-2-line',
    t: '发展理念',
    d: '不追求“跑得最快”，只追求“讲得最准”。先于热度的是求证，先于反转的是耐心——这是我们一直在做的事。',
  },
  {
    icon: 'ri-ink-bottle-line',
    t: '运营方式',
    d: '小团队 + 热心网友共同协作：你提供线索与完整经过，我们负责核实、整理、追更与复盘，让每一条内容都有出处可查。',
  },
];

const quotes = [
  {
    text: '追了一周的瓜终于在你们这儿看到完整复盘，以前都是只看个开头就下结论，现在学会看原文件了。',
    who: '在校同学 · 追更第 42 天',
    color: 'text-red-600',
    bg: 'bg-red-600/10',
  },
  {
    text: '没有标题党，也不急着下结论，把官方说明和两边说法都摆出来，这种“吃瓜”方式我挺认可。',
    who: '匿名网友 · 辟谣相关',
    color: 'text-teal-700',
    bg: 'bg-teal-600/10',
  },
  {
    text: '之前身边有人被造谣，是按你们 FAQ 里的方法留证和举报的，谢谢把理性科普放进吃瓜内容里。',
    who: '学生家长 · 反谣言',
    color: 'text-amber-600',
    bg: 'bg-amber-500/10',
  },
];

export default function About() {
  return (
    <section id="about" className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        kicker="关于我们"
        title="关于校园反转社，吃瓜也要较真"
        desc="从“转发最快的瓜友”到“讲得最完整的站点”，我们想成为你身边那个既会吃瓜、也守得住信息底线的内容伙伴。"
      />

      <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
        <div className="md:col-span-6">
          <div className="space-y-4">
            {pillars.map((p) => (
              <div key={p.t} className="flex gap-4 rounded-xl border border-stone-200 bg-white p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-stone-900 text-xl text-white">
                  <i className={p.icon} />
                </span>
                <div>
                  <h3 className="text-base font-bold text-stone-900">{p.t}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-stone-600">{p.d}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-5 rounded-xl border border-dashed border-stone-300 bg-white p-5 text-sm leading-relaxed text-stone-600">
            我们坚持<a href="#principle" className="font-semibold text-red-600">不扩散伤害性内容</a>、
            不靠夸张标题博眼球，也欢迎每一位读者指正与监督。
            想要一起追瓜、提供线索或聊聊内容，欢迎通过下方
            <a href="#contact" className="font-semibold text-red-600">投稿入口</a>找到我们。
          </div>
        </div>

        <div className="md:col-span-6">
          <h3 className="mb-4 text-base font-bold text-stone-900">大家眼中的反转社</h3>
          <div className="space-y-4">
            {quotes.map((q) => (
              <figure key={q.who} className="rounded-xl border border-stone-200 bg-white p-5">
                <div className="flex gap-1 text-amber-400">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-stone-700">“{q.text}”</blockquote>
                <figcaption className={`mt-3 inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${q.color} ${q.bg}`}>
                  <i className="ri-user-smile-line" /> {q.who}
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}